import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Chip, IconButton, List, ListItem, Typography } from '@mui/material';

interface ItemListProps {
  items: string[];
  itemType: 'chip' | 'list';
  isViewMode: boolean;
  onRemove: (index: number) => void;
  emptyMessage?: string;
}

function ItemList({ items, itemType, isViewMode, onRemove, emptyMessage = 'None specified' }: ItemListProps) {
  if (itemType === 'chip') {
    return (
      <div className="offering-item-list--chips">
        {items.map((item: string, index: number) => (
          <Chip key={index} label={item} onDelete={!isViewMode ? () => onRemove(index) : undefined} size="small" />
        ))}
        {items.length === 0 && isViewMode && <div className="offering-item-list--empty">{emptyMessage}</div>}
      </div>
    );
  }

  if (items.length === 0 && isViewMode) {
    return <div className="offering-item-list--empty">{emptyMessage}</div>;
  }

  return (
    <List className="offering-list">
      {items.map((item: string, index: number) => (
        <ListItem
          key={index}
          className="offering-list__item"
          secondaryAction={
            !isViewMode ? (
              <IconButton
                edge="end"
                onClick={() => onRemove(index)}
                size="small"
                className="offering-list__delete-button"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            ) : null
          }
        >
          <div className="offering-list__content">
            <Typography className="offering-list__number">{index + 1}.</Typography>
            <Typography className="offering-list__text">{item}</Typography>
          </div>
        </ListItem>
      ))}
    </List>
  );
}

export default ItemList;
